import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import StatusBadge from '../../StatusBadge';
import DownloadExtractButton from './DownloadExtractButton';
import StartExtractionButton from './StartExtractionButton';
import ViewFilesButton from './ViewFilesButton';
import DeleteFileButton from './DeleteFileButton';
import { deleteScormFileApi } from '../../../apis/scormUpload';
import { deleteScormFile as deleteScormFileAction } from '../../../store/slices/scormFilesSlice';
import { formatDate } from '../../../lib/utils';

function formatSize(size) {
    return `${size} MB`;
}
const ScormFile = ({ file }) => {
    const [localFile, setLocalFile] = useState(file);
    const dispatch = useDispatch();

    const handleStarted = (updatedFile) => {
        setLocalFile(updatedFile);
    };

    const handleDelete = async () => {
        if (!window.confirm('Are you sure you want to delete this scorm file?')) return;
        try {
            await deleteScormFileApi(localFile.id);
            toast.success('Scorm file deleted successfully');
            setLocalFile(null);
            dispatch(deleteScormFileAction(localFile.id));
        } catch (err) {
            toast.error('Failed to delete scorm file: ' + err);
        }
    };

    return (
        localFile && (
            <div
                className="list-group-item border-start border-4 border-primary list-group-item-action bg-light d-flex flex-wrap align-items-center justify-content-between my-1 shadow-sm rounded-2 px-4 py-3 border-0"
                style={{ minHeight: 70 }}
            >
                <div className="d-flex align-items-center flex-grow-1" style={{ minWidth: 0 }}>
                    <div className="me-3 text-primary" style={{ fontSize: 32 }}>
                        <i className="bi bi-file-earmark-zip"></i>
                    </div>
                    <div className="flex-grow-1" style={{ minWidth: 0 }}>
                        <div className="fw-semibold text-dark text-truncate" style={{ maxWidth: 220 }}>
                            {localFile.file_name}
                        </div>
                        <div className="small text-secondary">
                            {formatSize(localFile.file_size)} &nbsp;|&nbsp; {formatDate(localFile.created_at)}
                        </div>
                    </div>
                </div>
                <div className="d-flex align-items-center gap-2 flex-wrap mt-3 mt-md-0">
                    <StatusBadge status={localFile.status} />
                    <DownloadExtractButton file={localFile} />
                    {/* Show StartExtractionButton only if no ongoing extraction, else show Loader */}
                    {localFile.last_extraction &&
                    (localFile.last_extraction.status === 'in_progress' ||
                        localFile.last_extraction.status === 'dispatched') ? (
                        <i className="bi-arrow-repeat spin-animation"></i>
                    ) : (
                        <StartExtractionButton file={localFile} onStarted={handleStarted} />
                    )}
                    <ViewFilesButton file={localFile} />
                    <DeleteFileButton file={localFile} onDelete={handleDelete} />
                </div>
            </div>
        )
    );
};

export default ScormFile;
